import options from './drag-drop.directive';

export default {
    selector: 'dtDrag',
    options
};



// WEBPACK FOOTER //
// ./app/common/drag-drop/index.js